<script>
// @ts-check

import { postNativeMessage } from '@/helpers/mobile'
import { present } from '@/presenters/file'
import { mapGetters } from 'vuex'

export default {
  name: 'FileViewer',
  props: {
    file: {
      /** @type {import('vue').PropType<FileResource>} */
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('app', ['isLg']),
    ...mapGetters('mobileData', ['isMobileWrapperUser']),
    presented() {
      return present({ file: this.file.file, type: this.file.mime_type })
    }
  },
  methods: {
    onPdfClick() {
      if (this.isMobileWrapperUser) {
        const message = JSON.stringify({
          type: 'ukkopro_file_action',
          message: {
            fileData: this.file.file,
            name: this.file.file_name,
            action: 'open',
            type: this.file.mime_type
          }
        })
        postNativeMessage(message)
      } else {
        this.openPdfInNewTab()
      }
    },
    base64ToArrayBuffer(base64Str) {
      const binaryString = window.atob(base64Str)
      const binaryLen = binaryString.length
      const bytes = new Uint8Array(binaryLen)
      for (let i = 0; i < binaryLen; i += 1) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes
    },
    openPdfInNewTab() {
      const byte = this.base64ToArrayBuffer(this.file.file)
      const blob = new Blob([byte], { type: this.file.mime_type })
      setTimeout(() => {
        // iOS devices need this
        window.open(URL.createObjectURL(blob), '_blank')
      })
    }
  }
}
</script>

<template>
  <img
    v-if="presented.isImage"
    :src="presented.src"
    class="max-h-full max-w-full"
    alt=""
  />

  <div
    v-else-if="presented.isPdf && isLg"
    class="border border-secondary-200"
    style="height: 800px"
  >
    <iframe :src="presented.src" title="" height="100%" width="100%" />
  </div>

  <div v-else-if="presented.isPdf && !isLg">
    <SecondaryButton block @click="onPdfClick">
      {{
        isMobileWrapperUser
          ? $t('reports.open_pdf_in_new_tab_mobile_wrapper')
          : $t('reports.open_pdf_in_new_tab')
      }}
    </SecondaryButton>
  </div>
</template>
